<template>
  <BaseDashboard :auth-token="token" :base-api-params="apiParams">
    <template #filters>
      <PodcastersDropdown @select-podcaster="selectPodcaster" />
      <HostingDropdown
        :network-admin-id="networkAdminId"
        :selected-podcaster="selectedPodcaster"
        @select-hosting="selectHosting"
      />
      <ShowsDropdown
        :selected-podcaster="selectedPodcaster"
        :hosting-filter="selectedHosting"
        @select-show="selectShow"
        :class="[selectedPodcaster === 'all' ? 'tw-hidden' : '']"
      />
    </template>

    <ShowsTable
      v-if="selectedPodcaster !== 'all'"
      :data="showsData"
      :loading="loadingShowsData"
      :selected-show="selectedShow"
      @refresh-data="fetchShowsData"
    />
  </BaseDashboard>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import moment from "moment";
import { API_BASE_URL } from "@/consts";

import BaseDashboard from "@/components/dashboard/BaseDashboard.vue";
import PodcastersDropdown from "./components/PodcastersDropdown.vue";
import HostingDropdown from "./components/HostingDropdown.vue";
import ShowsDropdown from "./components/ShowsDropdown.vue";
import ShowsTable from "@/components/podcastadmin_dashboard_new/components/ShowsTable.vue";

const store = useStore();

const token = localStorage.getItem("networkAdminToken");
const networkAdminId = store.getters.networkAdmin?.network_id;

const selectedPodcaster = ref("all");
const selectedShow = ref("all");
const selectedHosting = ref("all");
const campaignType = ref(null);
const dates = ref([new Date(moment().subtract(1, "week")), new Date(moment())]);

const loadingShowsData = ref(false);
const showsData = ref([]);

const isProOrPlus = false;

const apiParams = computed(() => ({
  networkAdminId,
  podcasterId: selectedPodcaster.value,
  showId: selectedShow.value,
  campaignType: campaignType.value,
  isProOrPlus,
  hostingType: selectedHosting.value,
}));

const selectPodcaster = (podcasterId) => {
  selectedPodcaster.value = podcasterId;
  selectedShow.value = "all";
};

const selectHosting = (hosting) => {
  selectedHosting.value = hosting;
  selectedShow.value = "all";
};

const selectShow = (showId) => {
  selectedShow.value = showId;
};

const fetchShowsData = async () => {
  if (selectedPodcaster.value === "all") {
    showsData.value = [];
    return;
  }
  loadingShowsData.value = true;
  try {
    const params = {
      ...apiParams.value,
      startDate: moment(dates.value[0]).format("YYYY-MM-DD"),
      endDate: moment(dates.value[1]).format("YYYY-MM-DD"),
    };

    const url =
      selectedShow.value === "all"
        ? `${API_BASE_URL}/podcast_events/shows-data`
        : `${API_BASE_URL}/podcast_events/episode-data`;

    const { data } = await axios.get(url, {
      params,
      headers: { Authorization: `Bearer ${token}` },
    });

    if (data) {
      showsData.value =
        selectedShow.value === "all" ? data.shows_data : data.episode_data;
    }
  } catch (err) {
    console.error("Error fetching table data:", err);
  } finally {
    setTimeout(() => (loadingShowsData.value = false), 300);
  }
};

watch(apiParams, fetchShowsData, { deep: true, immediate: true });
</script>
